import React from "react";  
import { useNavigate } from "react-router-dom";  
import { ArrowLeft } from "lucide-react";  
import { motion } from "framer-motion";  
  
const AdminPageHeader = ({ title, subtitle, backTo, actions }) => {  
  const navigate = useNavigate();  
  
  return (  
    <motion.div  
      initial={{ opacity: 0, y: 8 }}  
      animate={{ opacity: 1, y: 0 }}  
      className="flex items-start sm:items-center justify-between gap-4 flex-col sm:flex-row"  
    >  
      <div className="flex items-center gap-3">  
        {backTo && (  
          <button  
            onClick={() => navigate(backTo)}  
            className="p-2 rounded-lg border border-gray-800 hover:border-gold/40 hover:bg-white/[0.03] transition-all"  
            title="Back"  
          >  
            <ArrowLeft size={16} className="text-gray-400" />  
          </button>  
        )}  
        <div className="w-1 h-10 bg-gradient-to-b from-gold to-yellow-600 rounded-full" />  
        <div>  
          <h1 className="text-2xl sm:text-3xl font-bold text-white leading-tight">{title}</h1>  
          {subtitle && <p className="text-gray-400 text-sm mt-1">{subtitle}</p>}  
        </div>  
      </div>  
      {actions && <div className="flex items-center gap-2">{actions}</div>}  
    </motion.div>  
  );  
};  
  
export default AdminPageHeader;  